import React, { useEffect } from 'react';
import Carsouel from '../Componenets/Carsouel/Carsouel'
import Slider from '../Componenets/Slider';
import { RiDoubleQuotesL } from "react-icons/ri";
import { FaPlus } from "react-icons/fa6";
import { RiDoubleQuotesR } from "react-icons/ri";





const Home = () => {

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
}, []);
  return (
    <>
      <div>
        <Carsouel />







        <section id="bt_section662752c981de6" class="boldSection topSemiSpaced gutter boxed inherit"><div class="port">
          <div class="boldCell"><div class="boldCellInner"><div class="boldRow btTableRow">
            <div class="boldRowInner">
              <div class="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein btMiddleVertical btDoublePadding animated" data-width="6">
                <div class="rowItemContent" style={{ marginLeft: "-60px" }}>
                  <header class="header btClear large btDash bottomDash  ">
                    <div class="dash hm1"><h2><span class="headline" style={{ color: "black" }}>About Us</span>
                    </h2></div>
                    <div class="btSubTitle hm1" style={{ textAlign: "justify" }}>At Automet Engineering Works, customer satisfaction is our top priority. We strive to exceed expectations by providing personalized solutions, timely delivery, and unparalleled customer service. Our dedication to excellence has earned us the trust and loyalty of our clients. </div></header>
                  <div class="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder"></div><div class="btText hm1"><p>Choose Automet Engineering Works for Your Manufacturing Needs.</p>
                  </div><div class="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder"></div><div class="boldRow " style={{ maxWidth: '530px', float: 'right' }}><div class="boldRowInner"><div class="rowItem rowInnerItem col-sm-6  btTextLeft"><div class="rowItemContent">
                    <div class="bpgPhoto out-right hm1">
                    <a href="#" target="_self" title=""></a>
                    <div class="boldPhotoBox hm11"><div class="bpbItem"><div class="btImage">
                      <img decoding="async"  style={{ borderRadius: "20px", height: "155px" }} src="./Images/bg3.jpeg" alt="" title="" /></div></div></div>
                    <div class="captionPane btDarkSkin btTextCenter">
                      <div class="captionTable">
                        <div class="captionCell">
                          <div class="captionTxt"></div>
                        </div>
                      </div>
                    </div></div><div class="btClear btSeparator bottomExtraSmallSpaced noBorder"></div><div class="btText"><p><small><em></em></small></p>
                    </div></div></div><div class="rowItem rowInnerItem col-sm-6  btTextLeft"><div class="rowItemContent"><div class="bpgPhoto btDefaultHoverType out-left hm1">
                      <a href="#" target="_self" title=""></a>
                      <div class="boldPhotoBox"><div class="bpbItem"><div class="btImage">
                        <img decoding="async" style={{ borderRadius: "20px" }} src="./Images/sw1.jpg" alt="" title="" /></div></div></div>
                      <div class="captionPane btDarkSkin btTextCenter">
                        <div class="captionTable">
                          <div class="captionCell">
                            <div class="captionTxt"></div>
                          </div>
                        </div>
                      </div></div><div class="btClear btSeparator bottomExtraSmallSpaced noBorder"></div><div class="btText"><p><small><em></em></small></p>
                      </div></div></div></div></div><div class="btClear btSeparator topSemiSpaced noBorder"></div></div></div><div class="rowItem col-md-6 col-sm-12 btTextCenter animate animate-fadein inherit btNoPadding animated" data-width="6"><div class="rowItemContent"><div class="bpgPhoto btHasComplexContent out-left hm1"><div class="btImage"><img decoding="async" style={{ borderRadius: "20px" }} src="https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/10/inner_large_2-1280x1280.jpg" alt="" title="" /></div></div><div class="btClear btSeparator bottomSemiSpaced noBorder"></div></div></div></div></div></div></div></div></section>



        <section style={{ marginLeft: "-80px" }}>
          <header className="header btClear large btDash bottomDash" style={{ marginLeft: "230px" }}>
            <div className="dash cl1">
              <h2>
                <span className="headline" style={{ color: "black" }}>Our Clients</span>
              </h2>
            </div>
            <div className="btSubTitle client" >
              At Automet Engineering Works, customer satisfaction is our top priority. We strive to exceed expectations by providing personalized solutions, timely delivery, and unparalleled customer service. Our dedication to excellence has earned us the trust and loyalty of our clients.
            </div>
          </header>
          <div className="btCarouselSmallNav boldClientList" style={{ marginLeft: "140px" }}>
            <div className="bclPort slick-initialized slick-slider"
              data-slides="6"
              data-autoplay="0"
              data-infinite=""
              data-slick="{&quot;pauseOnHover&quot;:true, &quot;pauseOnDotsHover&quot;:true,&quot;slidesToShow&quot;: 6, &quot;slidesToScroll&quot;: 1 }, &quot;responsive&quot;: [{ &quot;breakpoint&quot;: 480, &quot;settings&quot;: { &quot;slidesToShow&quot;: 1, &quot;slidesToScroll&quot;: 1 } },{ &quot;breakpoint&quot;: 768, &quot;settings&quot;: { &quot;slidesToShow&quot;: 2, &quot;slidesToScroll&quot;: 2 } },{ &quot;breakpoint&quot;: 920, &quot;settings&quot;: { &quot;slidesToShow&quot;: 3, &quot;slidesToScroll&quot;: 3 } },{ &quot;breakpoint&quot;: 1024, &quot;settings&quot;: { &quot;slidesToShow&quot;: 3, &quot;slidesToScroll&quot;: 3 } }]}"
            >
              <h4 className="nbs nsPrev slick-arrow slick-disabled" aria-disabled="true" style={{}}>
                <a><span className="nbsItem"></span></a>
              </h4>
              <div aria-live="polite" className="slick-list draggable">
                <div className="slick-track resposive_clients" style={{  role: "listbox" }}>
                  <div className="bclItem slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" style={{ width: '195px', tabindex: "-1", role: "option", ariaDescribedby: "slick-slide00" }}>
                    <div className="">
                      <div className="">
                        <div className="">
                          <a href="#" target="_self" title="" tabindex="0"></a>
                          <div className="boldPhotoBox">
                            <div className="bpbItem">
                              <div className="btImage clll"><img  style={{marginTop:"20px"}} decoding="async" src="./Images/1f.png" alt="" title="Client's website" /></div>
                            </div>
                          </div>
                        
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bclItem slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" style={{ width: '195px', tabindex: "-1", role: "option", ariaDescribedby: "slick-slide00" }}>
                    <div className="">
                      <div className="">
                        <div className="">
                          <a href="#" target="_self" title="" tabindex="0"></a>
                          <div className="boldPhotoBox">
                            <div className="bpbItem">
                              <div className="btImage clll1"><img decoding="async" style={{marginLeft:"30px"}} src="./Images/2f.png" alt="" title="Client's website" /></div>
                            </div>
                          </div>
                          <div className="captionPane btDarkSkin btTextCenter">
                           
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bclItem slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" style={{ width: '195px', tabindex: "-1", role: "option", ariaDescribedby: "slick-slide00" }}>
                    <div className="bclItemChild">
                      <div className="">
                        <div className="">
                          <a href="#" target="_self" title="" tabindex="0"></a>
                          <div className="boldPhotoBox">
                            <div className="bpbItem">
                              <div className="btImage clll2"><img decoding="async" style={{marginLeft:"60px"}} src="./Images/3f.png" alt="" title="Client's website" /></div>
                            </div>
                          </div>
                          <div className="captionPane btDarkSkin btTextCenter">
                          
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bclItem slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" style={{ width: '195px', tabindex: "-1", role: "option", ariaDescribedby: "slick-slide00" }}>
                    <div className="">
                      <div className="">
                        <div className="">
                          <a href="#" target="_self" title="" tabindex="0"></a>
                          <div className="boldPhotoBox">
                            <div className="bpbItem">
                              <div className="btImage clll3"><img style={{marginTop:"15px",marginLeft:"80px"}} decoding="async" src="./Images/4f.png" alt="" title="Client's website" /></div>
                            </div>
                          </div>
                          <div className="captionPane btDarkSkin btTextCenter">
                            <div className="">
                              <div className="">
                                <div className="">
                                  <header className="">
                           
                                  </header>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bclItem slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" style={{ width: '195px', tabindex: "-1", role: "option", ariaDescribedby: "slick-slide00" }}>
                    <div className="">
                      <div className="">
                        <div className="">
                          <a href="#" target="_self" title="" tabindex="0"></a>
                          <div className="boldPhotoBox">
                            <div className="bpbItem">
                              <div className="btImage clll4"><img decoding="async" style={{marginLeft:"100px"}} src="./Images/ht.JPG" alt="" title="Client's website" /></div>
                            </div>
                          </div>
                          <div className="captionPane btDarkSkin btTextCenter">
                            <div className="">
                              <div className="">
                                <div className="">
                                  <header className="">
                                    <div className="btSuperTitle"><span></span></div>
                                  </header>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Add more carousel items here */}
                </div>
              </div>

            </div>
          </div>
        </section>

        <section
          id="bt_section6627350a9c94e"
          data-parallax={0}
          data-parallax-offset={0}
          className="boldSection topSpaced bottomSemiSpaced btDarkSkin gutter boxed inherit btParallax wBackground cover wBackground cover btBackgroundOverlay btSolidDarkBackground"
          style={{
            backgroundImage:
              'url("https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/10/background-lab-light.jpg")',
            backgroundPosition: "50% 0.0198688px",
            marginTop: "20px"
          }}
        >
          <div className="port">
            <div className="boldCell">
              <div className="boldCellInner">
                <div className="boldRow ">
                  <div className="boldRowInner">
                    <div
                      className="rowItem col-md-8 col-ms-12 btTextLeft animate animate-fadein inherit animated"
                      data-width={8}
                    >
                      <div className="rowItemContent">
                        <span className="btIco btIcoFilledType btIcoLargeSize btIcoAccentColor btIconCircleShape" style={{ fontSize: "60px", marginLeft: "-20px" }}>
                          <RiDoubleQuotesL />
                        </span>
                        <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder">
                          <hr />
                        </div>
                        <header className="header btClear large  ">
                          <div className="dash">
                            <h2>
                              <span className="headline  headline1" >
                                Automet Engineering:  Your One-Stop Shop for Precision Metal Manufacturing
                                Looking for high-quality metal components for your project? Look no further than Automet Engineering! We specialized
                              </span>
                            </h2>
                          </div>

                          <div className="btSubTitle" style={{ marginLeft: "800px", fontSize: "60px", marginTop: "-50px" }}> <RiDoubleQuotesR /></div>
                        </header>
                        <div className="btClear btSeparator bottomSemiSpaced noBorder">
                          <hr />
                        </div>
                      </div>
                    </div>
                    <div
                      className="rowItem col-md-4 col-ms-12 btTextLeft"
                      data-width={4}
                    >
                      <div className="rowItemContent" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          id="bt_section6627350a9cb85"
          className="boldSection topSmallSpaced btDarkSkin  gutter boxed inherit"
        >
          <div className="port">
            <div className="boldCell">
              <div className="boldCellInner">
                <div className="boldRow btTableRow">
                  <div className="boldRowInner">
                    <div
                      className="rowItem col-md-8 col-ms-12 btTextLeft animate animate-fadein btMiddleVertical animated"
                      data-width={8}
                    >
                      <div className="rowItemContent">
                        <header className="header btClear small  ">
                          <div className="dash">
                            <h4>
                              <span className="headline  headline2">
                                Choose Automet Engineering Works for Your Manufacturing Needs
                              </span>
                            </h4>
                          </div>
                        </header>
                        <div className="btClear btSeparator bottomSmallSpaced noBorder">
                          <hr />
                        </div>
                      </div>
                    </div>
                    <div
                      className="rowItem col-md-4 col-ms-12 btTextRight animate animate-fadein inherit animated"
                      data-width={4}
                    >
                      <div className="rowItemContent">
                        <a
                          href="/contact"
                          className="btBtn btnn btBtn btnFilledStyle btnAccentColor btnMedium btnNormalWidth btnRightPosition btnNoIcon"
                        >
                          <span className="btnInnerText ">CONTACT US</span>
                        </a>
                        <div className="btClear btSeparator bottomSmallSpaced noBorder">
                          <hr />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          id="bt_section6627350a9cec2"
          className="boldSection topSpaced bottomSpaced  gutter boxed inherit "
          style={{ backgroundColor: "#f2f1ed  !important", marginTop: "-100px",marginLeft:"-30px"}}
        >
          <div className="port">
            <div className="boldCell ">
              <div className="boldCellInner">
                <div className="boldRow ">
                  <div className="boldRowInner">
                    <div
                      className="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit animated"
                      data-width={6}
                    >
                      <div className="rowItemContent">
                        <header className="header btClear large btDash bottomDash pp1 ">
                          <div class="dash dash1"><h2><span class="headline" style={{ color: "black" }}>Products</span>
                          </h2></div>

                          <div className="btSubTitle btSubTitle5" >
                            We thrive on innovation and embrace emerging technologies to stay at the forefront of the industry. By continually investing in the latest tools and techniques, we enhance our manufacturing processes, driving efficiency, and delivering superior products to our clients.
                            {" "}
                          </div>
                        </header>
                        <div className="btClear btSeparator topSemiSpaced noBorder">
                          <hr />
                        </div>
                      </div>
                    </div>
                    <div
                      className="rowItem col-md-6 col-sm-12 btTextLeft inherit"
                      data-width={6}
                    >
                      <div className="rowItemContent" />
                    </div>
                  </div>
                </div>
                <div className="boldRow btTableRow">
                  <div className="boldRowInner">
                    <div
                      className=" bgimg rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein btBottomVertical wBackground cover animated"
                      style={{
                        backgroundImage:
                          "url(./Images/p.jpg)",
                        borderRadius: "20px"
                      }}
                      data-width={6}
                    >
                      <div className="rowItemContent">

                        <div className="btClear btSeparator bottomSmallSpaced noBorder">
                          <hr />
                        </div>
                      </div>
                    </div>
                    <div
                      className="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit animated"
                      data-width={6}
                    >
                      <div className="rowItemContent">
                        <div className="btLatestPostsContainer verticalPosts ">
                          <div className="btSingleLatestPost col-md-12 col-ms-12  inherit">
                            <div className="btSingleLatestPostImage btTextCenter">
                              <div className="bpgPhoto btZoomInHoverType out-right">
                                <a
                                  href="/product1"
                                  target="_self"
                                  title=""
                                />
                                <div className="">
                                  <div className="">
                                    <div className="">
                                      <img style={{ borderRadius: "20px" }}
                                        decoding="async"
                                        src="./Images/p12.jpg"
                                        alt=""
                                        title=""
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="captionPane btDarkSkin btTextCenter">
                                  <div className="captionTable">

                                    <div className="">
                                      <div className="captionTxt" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="btSingleLatestPostContent">
                              <header className="header btClear small">
                                <div className="btSuperTitle">


                                </div>
                                <div className="dash">
                                  <h4>
                                    <span className="headline">
                                      <a
                                        href="/product1"
                                        target="_self"
                                      >
                                        PERFORATED SHEETS
                                      </a>
                                    </span>
                                  </h4>
                                </div>
                              </header>
                              <p className="btLatestPostContent">
                                Perforated Sheets have been a recent addition to the industry. Such improved metals are preferred over PVC and other plastic alternatives as they become more productive and long-lasting after the metal improvement. Stainless Steel has always been a product of people's liking, and the demand for it has, therefore, never gone down.
                              </p>
                            </div>
                          </div>
                          <div className="btSingleLatestPost col-md-12 col-ms-12  inherit">
                            <div className="btSingleLatestPostImage btTextCenter">
                              <div className="bpgPhoto btZoomInHoverType">
                                <a
                                  href="/products2"
                                  target="_self"
                                  title=""
                                />
                                <div className="boldPhotoBox">
                                  <div className="bpbItem">
                                    <div className="btImage">
                                      <img
                                        decoding="async"
                                        src="./Images/pc33.jpg"
                                        alt=""
                                        title=""
                                        style={{ borderRadius: "20px" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="captionPane btDarkSkin btTextCenter">
                                  <div className="captionTable">
                                    <div className="">
                                      <div className="captionTxt" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="btSingleLatestPostContent">
                              <header className="header btClear small">
                                <div className="btSuperTitle">

                                </div>
                                <div className="dash">
                                  <h4>
                                    <span className="headline">
                                      <a
                                        href="/product2"
                                        target="_self"
                                      >
                                        PRESS COMPONENETS
                                      </a>
                                    </span>
                                  </h4>
                                </div>
                              </header>
                              <p className="btLatestPostContent">
                                We manufacture different types of sheet metals press components, parts & products for automotive, locomotive & other industries like brackets, hinges, frames, pads, circles, etc
                              </p>
                            </div>
                          </div>
                          <div className="btSingleLatestPost col-md-12 col-ms-12  inherit">
                            <div className="btSingleLatestPostImage btTextCenter">
                              <div className="bpgPhoto btZoomInHoverType out-right">
                                <a
                                  href="/products3"
                                  target="_self"
                                  title=""
                                />
                                <div className="boldPhotoBox">
                                  <div className="bpbItem">
                                    <div className="btImage">
                                      <img
                                        decoding="async"
                                        src="./Images/fs3.png"
                                        alt=""
                                        title=""
                                        style={{ borderRadius: "20px" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="captionPane btDarkSkin btTextCenter">
                                  <div className="captionTable">
                                    <div className="">
                                      <div className="captionTxt" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="btSingleLatestPostContent">
                              <header className="header btClear small">
                                <div className="btSuperTitle">

                                </div>
                                <div className="dash">
                                  <h4>
                                    <span className="headline">
                                      <a
                                        href="/product3"
                                        target="_self"
                                      >
                                        FUEL STRAINERS
                                      </a>
                                    </span>
                                  </h4>
                                </div>
                              </header>
                              <p className="btLatestPostContent">
                                Fuel strainers ensure that only clean, contaminant-free fuel is supplied to the engine, which helps optimize its performance. By preventing impurities from reaching sensitive engine components, fuel strainers contribute to smoother operation and improved fuel efficiency
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section
          id="bt_section6627350a9a40a"
          className="boldSection btDarkSkin btAccentColorBackground gutter boxed inherit"
          style={{ marginTop: "-60px",marginLeft:"" }}
        >
          <div className="port">
            <div className="boldCell">
              <div className="boldCellInner">
                <div className="boldRow btTableRow">
                  <div className="boldRowInner">
                    <div
                      className="rowItem col-md-2 col-sm-4 col-ms-12 btTextCenter animate animate-fadein inherit btNoPadding animated"
                      data-width={2}
                    >
                      <div className="rowItemContent">
                        <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder">
                          <hr />
                        </div>
                        <div className="bpgPhoto btDefaultHoverType btCircleImage in-right">
                          <div className="btImage">
                            <img
                              decoding="async"
                              src="./Images/sp1.jpg"
                              alt=""
                              title=""
                            />
                          </div>
                        </div>
                        <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder">
                          <hr />
                        </div>
                      </div>
                    </div>
                    <div
                      className="rowItem col-md-8 col-ms-12 btTextLeft animate animate-fadein btMiddleVertical animated"
                      data-width={8}
                    >
                      <div className="rowItemContent">
                        <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder">
                          <hr />
                        </div>
                        <div className="btClear btSeparator topExtraSmallSpaced noBorder">
                          <hr />
                        </div>
                        <div className="btText">
                          <blockquote>
                            <p className='p1'>
                              “We take pride in our ability to tackle complex projects and deliver results that make a difference. Whether it's catering to diverse market segments or fulfilling unique customer requirements, Automet Engineering Works is committed to delivering value and driving success for our clients. ”
                            </p>
                            <p>
                              <cite></cite>
                            </p>
                          </blockquote>
                        </div>
                        <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder">
                          <hr />
                        </div>
                      </div>
                    </div>
                    <div
                      className="rowItem col-md-2 col-sm-4 col-ms-12 btTextRight animate animate-fadein btBottomVertical animated"
                      data-width={2}
                    >
                      <div className="rowItemContent">

                        <a
                          href="/contact"
                          className="btBtn btBtn btnOutlineStyle btnNormalColor btnSmall btnNormalWidth btnRightPosition btnNoIcon"
                          style={{ backgroundColor: "#FBBD02" }}
                        >
                          <span className="btnInnerText">READ MORE</span>
                        </a>
                        <div className="btClear btSeparator topSemiSpaced noBorder">
                          <hr />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Slider />


      </div>
    </>
  )
}

export default Home
